"use strict";
//TODO Hack to get past WebPack issues...
// needs to fill in navigator value only if it does not already exist (node)
if (global && !global.navigator) {
    global.navigator = {
        platform: "MacIntel",
        userAgent:
            "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_12_1) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/54.0.2840.98 Safari/537.36",
        appVersion:
            "5.0 (Macintosh; Intel Mac OS X 10_12_1) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/54.0.2840.98 Safari/537.36",
    };
}

const dataOS = [
    {
        string: navigator.platform,
        subString: "Win",
        identity: "Windows",
    },
    {
        string: navigator.platform,
        subString: "Mac",
        identity: "Mac",
    },
    {
        string: navigator.userAgent,
        subString: "iPhone",
        identity: "iPhone/iPod",
    },
    {
        string: navigator.platform,
        subString: "Linux",
        identity: "Linux",
    },
];

/**
 * BrowserDetails module gives you Browser Detection information.
 * @module BrowserDetails
 */
const BrowserDetails = {
    retrieveOsVersion: function () {
        let result;
        const platform = this.searchString(dataOS) || undefined;
        switch (platform.toLowerCase()) {
            case "windows":
                //If Windows 7
                if (navigator.appVersion.indexOf("Windows NT 6.1") !== -1) {
                    result = "Windows 7";
                }
                //If Windows XP
                else if (navigator.appVersion.indexOf("Windows NT 5.1") !== -1) {
                    result = "Window XP";
                }
                //If Windows 2003
                else if (navigator.appVersion.indexOf("Windows NT 5.2") !== -1) {
                    result = "Windows2003";
                }
                //If Windows Vista
                else if (navigator.appVersion.indexOf("Windows NT 6.0") !== -1) {
                    result = "Windows Vista";
                }
                break;
            case "mac":
                if (navigator.userAgent.indexOf("Mac OS X 10_7") !== -1) {
                    result = "Lion";
                } else if (navigator.userAgent.indexOf("Mac OS X 10_6") !== -1) {
                    result = "Snow Leopard";
                }
                break;
            case "linux":
                if (navigator.userAgent.indexOf("Ubuntu") !== -1) {
                    result = "Ubuntu";
                    if (navigator.userAgent.indexOf("_64") !== -1) {
                        result = result + "_64bit";
                    }
                } else {
                    result = "Unknown";
                }
                break;
            default:
                result = "Unknown";
                break;
        }
        return result;
    },

    retrieveBrowser: function () {
        // Detect Firefox/Waterfox
        if (
            navigator.userAgent.indexOf("Firefox/") !== -1 &&
            navigator.userAgent.indexOf("Seamonkey/") === -1
        ) {
            return "Firefox";
        }
        // Detect Seamonkey
        if (navigator.userAgent.indexOf("Seamonkey/") !== -1) {
            return "Seamonkey";
        }
        // Detect Chromium
        if (navigator.userAgent.indexOf("Chromium/") !== -1) {
            return "Chromium";
        }
        // Detect Edge
        if (navigator.userAgent.indexOf("Edge/") !== -1) {
            return "Edge";
        }
        // Detect Safari
        if (
            navigator.userAgent.indexOf("Safari/") !== -1 &&
            navigator.userAgent.indexOf("Chrome/") === -1 &&
            navigator.userAgent.indexOf("Chromium/") === -1
        ) {
            return "Safari";
        }
        // Detect Opera
        if (
            navigator.userAgent.indexOf("Opera/") !== -1 ||
            navigator.userAgent.indexOf("OPR/") !== -1
        ) {
            return "Opera";
        }
        // Detect Internet Explorer
        if (navigator.userAgent.indexOf("MSIE") !== -1) {
            return "Explorer";
        }
        // Detect Chrome
        if (
            navigator.userAgent.indexOf("Chrome/") !== -1 &&
            navigator.userAgent.indexOf("Chromium/") === -1
        ) {
            return "Chrome";
        }
    },

    searchString: function (data) {
        for (let i = 0; i < data.length; i++) {
            const dataString = data[i].string;
            const dataProp = data[i].prop;
            this.versionSearchString = data[i].versionSearch || data[i].identity;
            if (dataString) {
                if (dataString.indexOf(data[i].subString) !== -1) {
                    return data[i].identity;
                }
            } else if (dataProp) {
                return data[i].identity;
            }
        }
    },

    /*
    searchVersion: function (dataString) {
        const index = dataString.indexOf(this.versionSearchString);
        if (index === -1) {
            return;
        }
        return parseFloat(dataString.substring(index + this.versionSearchString.length + 1));
    },

     */

    searchVersion: function (dataString) {
        if (!dataString) {
            return;
        }
    },

    /**
     * @property userAgent {string} The raw user Agent string.
     */
    userAgent: navigator.userAgent,

    /**
     * @property appVersion {string} The raw user appVersion string.
     */
    appVersion: navigator.appVersion,
};

/**
 * @property browser {string} The name of the browser.
 */
BrowserDetails.browser = BrowserDetails.retrieveBrowser() || "Unknown";

/**
 * @property browserVersion {string} The version of the browser.
 */
BrowserDetails.browserVersion =
    BrowserDetails.searchVersion(navigator.userAgent) ||
    BrowserDetails.searchVersion(navigator.appVersion) ||
    "Unknown";

/**
 * @property os {string} The name of the os this browser is running on.
 */
BrowserDetails.os = BrowserDetails.searchString(dataOS) || navigator.platform || "Unknown";

/**
 * @property osVersion {string} The version of the os this browser is running on.
 */
BrowserDetails.osVersion = BrowserDetails.retrieveOsVersion() || "Unknown";

module.exports = BrowserDetails;
